module.exports = __webpack_public_path__ + "img/microphone-lines-slash.44aa7285.svg";